import { ensureClaimCorn } from '@eigtech/shared-corn-helper'
import { ensureTemplateCorn, isDocumentTemplate } from '@eigtech/templates-types'
import { withRequiredPermissions } from '@/lib/permissions'
import { GenerateDocumentStatus as BaseGenerateDocumentStatus } from '@eigtech/ui-shared-documator-web'
import { useGetTemplate } from '@eigtech/ui-shared-templates'
import {
  Alert,
  AlertContent,
  AlertDescription,
  AlertIcon,
  AlertTitle,
} from '@eigtech/ui/components/alert'
import { Spinner } from '@eigtech/ui/components/spinner'
import { createFileRoute } from '@tanstack/react-router'
import { TriangleAlert } from 'lucide-react'

export const Route = createFileRoute(
  '/_auth/claims/$claimNumber/_layout/generate-document_/status/$templateId'
)({
  component: () => <Component />,
})

function GenerateDocumentStatus() {
  const { claimNumber, templateId } = Route.useParams()

  const { data: template, isPending, isError } = useGetTemplate({ id: templateId })

  if (isPending) {
    return (
      <div className="flex items-center justify-center">
        <Spinner className="size-28 text-blue-500" />
      </div>
    )
  }

  if (isError) {
    return (
      <Alert variant="destructive">
        <AlertIcon>
          <TriangleAlert />
        </AlertIcon>
        <AlertContent>
          <AlertTitle>Could not retrieve document templates</AlertTitle>
          <AlertDescription>
            Please try refreshing the page to try again. If the issue persists, contact EIG Tech
            Support.
          </AlertDescription>
        </AlertContent>
      </Alert>
    )
  }

  if (template && !isDocumentTemplate(template)) {
    return (
      <Alert variant="warning">
        <AlertIcon>
          <TriangleAlert />
        </AlertIcon>
        <AlertContent>
          <AlertTitle>Incorrect template type</AlertTitle>
          <AlertDescription>
            The selected template is not a document template (it is a{' '}
            {template.type.split(':').pop()} template). Please select a document template in order
            to proceed
          </AlertDescription>
        </AlertContent>
      </Alert>
    )
  }

  return (
    <BaseGenerateDocumentStatus
      entityId={ensureClaimCorn(claimNumber)}
      template={template}
      templateId={ensureTemplateCorn(templateId)}
    />
  )
}

const Component = withRequiredPermissions(GenerateDocumentStatus, {
  requiredPermissions: [{ action: 'create', subject: 'draftDocument' }],
})
